import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import usersSlice from "./slice/users-slice";
import settingsSlice from "./slice/settings-slice";

const usersConfig = { key: "users", storage, blacklist: ["error_message", "is_loading"] };

const rootReducer = combineReducers({
  users: persistReducer(usersConfig, usersSlice),
  settings: settingsSlice,
});

export default rootReducer;
